import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import useComponents from "@/components";
import usePlugins from "@/plugins";
import "./styles/main.scss"; // 引入全局 SASS 文件

Vue.config.productionTip = false;

useComponents(Vue);
usePlugins(Vue);

new Vue({
  router,
  render: (h) => h(App),
}).$mount("#app");
